import { render } from "./Mapa.vue?vue&type=template&id=28ea2f1d&scoped=true"
import script from "./Mapa.vue?vue&type=script&lang=js"
export * from "./Mapa.vue?vue&type=script&lang=js"

import "./Mapa.vue?vue&type=style&index=0&id=28ea2f1d&scoped=true&lang=css"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ea2f1d"]])

export default __exports__